export { default as Judging } from "../SHARED/grading";

import routes from "./routes";
import * as Anchors from "./anchors";
export default {
  routes,
  Anchors,
};
